import React from 'react';
import { Helmet } from 'react-helmet-async';
import './FloatingMeetButton.css';

const FloatingMeetButton = () => {
  const handleClick = (e) => {
    e.preventDefault();
    if (window.Calendly) {
      window.Calendly.initPopupWidget({ url: 'https://calendly.com/lkktechsolutions/30min' });
    } else {
      window.open('https://calendly.com/lkktechsolutions/30min', '_blank', 'width=800,height=600');
    }
  };

  return (
    <>
      <Helmet>
        <link href="https://assets.calendly.com/assets/external/widget.css" rel="stylesheet" />
        <script src="https://assets.calendly.com/assets/external/widget.js" type="text/javascript" async></script>
      </Helmet>
      <a
        href="#"
        onClick={handleClick}
        className="floating-meet-btn animate-float"
      >
        <i className="bi bi-calendar-event me-2"></i>
        Meet Now
      </a>
    </>
  );
};

export default FloatingMeetButton;
